import * as c from '../constants/UpdateStudentConstants'

const initialState = {
  data: {},
  fetching: false,
  fetched: true,
  submitting: false,
  submitted: false,
  error: null,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case c.FETCH_STUDENT_LOCATION_PENDING:
      return {
        ...state,
        fetching: true,
        fetched: false,
        submitting: false,
        submitted: false,
        error: null,
      }

    case c.FETCH_STUDENT_LOCATION_FULFILLED:
      return { ...state, fetching: false, fetched: true, data: { ...payload } }

    case c.FETCH_STUDENT_LOCATION_REJECTED:
      return { ...state, fetching: false, fetched: false, error: payload }

    case c.UPDATE_STUDENT_LOCATION_PENDING:
      return { ...state, submitting: true, submitted: false, error: null }

    case c.UPDATE_STUDENT_LOCATION_FULFILLED:
      return { ...state, submitting: false, submitted: true }

    case c.UPDATE_STUDENT_LOCATION_REJECTED:
      return { ...state, submitting: false, submitted: false, error: payload }

    case c.RESET_STUDENT_LOCATION:
      return initialState

    default:
      return state
  }
}
